import React from 'react'
import { useTranslate, required, Form } from 'react-admin'
import { NumberInput } from 'src/components/uiElements/fields/NumberInput'
import SaveIcon from '@mui/icons-material/Save'
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Button,
  DialogActions,
  Box,
  Typography,
} from '@mui/material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import LoadingButton from '@mui/lab/LoadingButton'
import { useCardId } from 'src/components/pages/sales/reservation/context/CardIdContext'
import { CheckboxLabels } from 'src/components/uiElements/fields/CheckboxLabels'
import { hasPermissionFunction } from 'src/helper/HasPermission'
import {
  VIEW_LIQUIDATION_RETAIL,
  VIEW_LIQUIDATION_SUPPLIER,
  VIEW_LIQUIDATION_WHOLESALER,
} from 'src/helper/Permission'

export const PricingAirModal = ({
  open,
  handleClose,
  titleModal,
  onSubmit,
  loadingButton
}) => {
  const translate = useTranslate()
  const { cardId } = useCardId()

  const postSave = (data) => {
    onSubmit && onSubmit(data, cardId)
  }

  const getOptionsLiquidationByPermissions = () => {
    const options = []
    if (hasPermissionFunction('pricing', VIEW_LIQUIDATION_WHOLESALER)) {
      options.push({ key: 'liquidation_wholesaler', name: 'Liquidación mayorista' })
    }
    if (hasPermissionFunction('pricing', VIEW_LIQUIDATION_SUPPLIER)) {
      options.push({ key: 'liquidation_supplier', name: 'Liquidación proveedor' })
    }
    if (hasPermissionFunction('pricing', VIEW_LIQUIDATION_RETAIL)) {
      options.push({ key: 'liquidation_retail', name: 'Liquidación minorista' })
    }
    return options
  }

  return (
    <Dialog open={open} maxWidth='lg' fullWidth={true}>
      <DialogTitle>{titleModal}</DialogTitle>
      <DialogContent>
        <Form id='post_create_form_air' warnWhenUnsavedChanges onSubmit={postSave}>
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.additional_fare')}>
              <NumberInput
                source='pricing_relation.[0].additional_fare'
                label=''
                fullWidth
                thousandSeparator='.'
                decimalSeparator=','
                defaultValue={0}
                decimalScale={2}
              />
            </EditInputsWrap>

            <EditInputsWrap label={translate('ra.field.net_price')}>
              <NumberInput
                source='pricing_relation.[0].net_price'
                label=''
                fullWidth
                defaultValue={0}
                thousandSeparator='.'
                decimalSeparator=','
                decimalScale={2}
              />
            </EditInputsWrap>

            <EditInputsWrap label={translate('ra.field.markup')}>
              <NumberInput
                source='pricing_relation.[0].markup'
                label=''
                fullWidth
                thousandSeparator='.'
                defaultValue={0}
                decimalSeparator=','
                decimalScale={2}
              />
            </EditInputsWrap>

            <EditInputsWrap label={translate('ra.field.fee')}>
              <NumberInput
                source='pricing_relation.[0].fee'
                label=''
                fullWidth
                thousandSeparator='.'
                defaultValue={0}
                decimalSeparator=','
                decimalScale={2}
              />
            </EditInputsWrap>

            <EditInputsWrap label={translate('ra.field.final_price')}>
              <NumberInput
                source='pricing_relation.[0].final_price'
                label=''
                fullWidth
                defaultValue={0}
                thousandSeparator='.'
                decimalSeparator=','
                decimalScale={2}
              />
            </EditInputsWrap>

            <EditInputsWrap label={translate('ra.field.net_agency')}>
              <NumberInput
                source='pricing_relation.[0].net_agency'
                label=''
                fullWidth
                thousandSeparator='.'
                decimalSeparator=','
                defaultValue={0}
                decimalScale={2}
              />
            </EditInputsWrap>


            <EditInputsWrap label={translate('ra.field.expenses')}>
              <NumberInput
                source='pricing_relation.[0].expenses'
                label=''
                fullWidth
                thousandSeparator='.'
                decimalSeparator=','
                defaultValue={0}
                decimalScale={2}
              />
            </EditInputsWrap>

            <EditInputsWrap label={translate('ra.field.num_pax')}>
              <NumberInput
                source='pricing_relation.[0].num_pax'
                label=''
                fullWidth
                defaultValue={0}
                thousandSeparator='.'
                decimalSeparator=','
                decimalScale={2}
              />
            </EditInputsWrap>

            <EditInputsWrap label={translate('ra.field.num_segments')}>
              <NumberInput
                source='pricing_relation.[0].num_segments'
                label=''
                fullWidth
                defaultValue={0}
                thousandSeparator='.'
                decimalSeparator=','
                decimalScale={2}
              />
            </EditInputsWrap>

            <EditInputsWrap label={translate('ra.field.additional_cost')}>
              <NumberInput
                source='pricing_relation.[0].additional_cost'
                label=''
                defaultValue={0}
                fullWidth
                thousandSeparator='.'
                decimalSeparator=','
                decimalScale={2}
              />
            </EditInputsWrap>

            <EditInputsWrap label={translate('ra.field.final_sale')}>
              <NumberInput
                source='pricing_relation.[0].final_sale'
                label=''
                fullWidth
                defaultValue={0}
                thousandSeparator='.'
                decimalSeparator=','
                decimalScale={2}
              />
            </EditInputsWrap>

            <EditInputsWrap label={translate('ra.field.sale_discount')}>
              <NumberInput
                source='pricing_relation.[0].sale_discount'
                label=''
                fullWidth
                defaultValue={0}
                thousandSeparator='.'
                decimalSeparator=','
                decimalScale={2}
              />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.bad_practice')}>
              <NumberInput
                source='pricing_relation.[0].bad_practice'
                label=''
                fullWidth
                defaultValue={0}
                thousandSeparator='.'
                decimalSeparator=','
                decimalScale={2}
              />
            </EditInputsWrap>
            <EditInputsWrap label={'Fee ancillary baggage'}>
              <NumberInput
                source='pricing_relation.[0].ancillary_markup_1'
                label=''
                fullWidth
                defaultValue={0}
                thousandSeparator='.'
                decimalSeparator=','
                decimalScale={2}
              />
            </EditInputsWrap>
            
            <EditInputsWrap label={translate('ra.field.markup_additional')}>
              <NumberInput
                source='pricing_relation.[0].markup_additional'
                label=''
                fullWidth
                defaultValue={0}
                thousandSeparator='.'
                decimalSeparator=','
                decimalScale={2}
              />
            </EditInputsWrap>

            <EditInputsWrap label={translate('ra.field.debit')}>
              <NumberInput
                source='pricing_relation.[0].debit'
                label=''
                fullWidth
                defaultValue={0}
                thousandSeparator='.'
                decimalSeparator=','
                decimalScale={2}
              />
            </EditInputsWrap>

            <EditInputsWrap label={translate('ra.field.gateway_expenses')}>
              <NumberInput
                source='pricing_relation.[0].installment_cost'
                label=''
                fullWidth
                defaultValue={0}
                thousandSeparator='.'
                decimalSeparator=','
                decimalScale={2}
              />
            </EditInputsWrap>

          </Grid>
          <Box>
            <Typography
              variant='h6'
              color='inherit'
              sx={{
                flex: 1,
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
              }}
              id='recalculate_liquidation_rule'
            >
              {translate('ra.title.recalculate_liquidation_rule')}
            </Typography>
            <Box paddingX={'10px'} width={'auto'}>
              <CheckboxLabels
                source={'pricing_relation.[0].liquidations'}
                validate={[required()]}
                choices={getOptionsLiquidationByPermissions()}
                defaultValue={getOptionsLiquidationByPermissions().map((choice) => choice.key)}
              />
            </Box>
          </Box>
        </Form>
      </DialogContent>
      <DialogActions className='dialog-actions' style={{ marginTop: '20px' }}>
        <LoadingButton
          loading={loadingButton}
          variant='contained'
          startIcon={<SaveIcon />}
          form='post_create_form_air'
          type='submit'
        >
          {translate('ra.action.save_and_recalculate_liquidation')}
        </LoadingButton>
        <Button onClick={handleClose} variant='outlined' color='error'>
          {translate('ra.action.cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

